import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const NotificationToast = ({ notification, onClose }) => {
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification, onClose]);

  if (!notification) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return { name: 'CheckCircle2', color: '#10b981' };
      case 'error':
        return { name: 'XCircle', color: '#ef4444' };
      case 'warning':
        return { name: 'AlertTriangle', color: '#f59e0b' };
      case 'info':
      default:
        return { name: 'Info', color: '#3b82f6' };
    }
  };

  const getBgColor = (type) => {
    switch (type) {
      case 'success':
        return 'bg-success/10 border-success/20';
      case 'error':
        return 'bg-error/10 border-error/20';
      case 'warning':
        return 'bg-warning/10 border-warning/20';
      case 'info':
      default:
        return 'bg-primary/10 border-primary/20';
    }
  };

  const icon = getIcon(notification?.type);

  return (
    <div className="fixed top-4 left-4 z-50 animate-slide-in">
      <div className={`bg-card border rounded-lg shadow-warm p-4 min-w-[300px] max-w-md ${getBgColor(notification?.type)}`}>
        <div className="flex items-start gap-3">
          <Icon name={icon?.name} size={20} color={icon?.color} />
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-foreground mb-1">
              {notification?.title}
            </h4>
            <p className="text-xs text-muted-foreground">
              {notification?.message}
            </p>
            {notification?.timestamp && (
              <p className="text-xs text-muted-foreground/60 mt-1 font-data">
                {new Date(notification?.timestamp)?.toLocaleTimeString('ar-EG')}
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationToast;